import BaseMixin from "BaseMixin"
import PageMixin from "../../../mixins/PageMixin"
import Organization from "Models/Organization"
import template from "./OrganizationSubmitted.html"
import WindowInterface from "Interfaces/WindowInterface"

declare const window: WindowInterface

export default {
  // routes(prefix: string): Array<any> {
  //   return [{
  //     path: `/${prefix}/organizations/submitted/:id`,
  //     title: 'app-organization-submitted'
  //   }]
  // },
  
  mixins: [BaseMixin, PageMixin],

  template: template,

  data() {
    return {
      title: "",
      subtitle: "",
      paragraph: ""
    }
  },

  async mounted() {
    this.app.showLoading()
    this.organization = new Organization()
    this.app.showLoading()
    this.organization.document.id = this.$route.params.id
    await this.organization.load()

    this.title = this.t("app-organization-submitted-headline")

    this.subtitle = this.t("app-organization-submitted-subtitle", {
      organizationName: this.organization.localizedAttributes[window.app.language.langcode].field_display_title
    })

    this.paragraph = this.t("app-organization-submitted-paragraph", {
      email: this.organization.attributes.contactEmail
    })

    this.ready()
  }
}

